if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $(".property-highlights__items").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    dots: true,
                    arrows: false,
                    variableWidth: false,
                    slidesToShow: 1,
                }
            }
        ]

    });

    $(".gallery-block__list").slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        variableWidth: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]

    });


    $(".spaces__image").slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        dots: true,
        arrows: false,
        variableWidth: true,
        asNavFor: '.spaces__text',
        appendDots: '.spaces__dots',
        customPaging: function (slider, i) {
            var title = $(slider.$slides[i]).data('title');
            return title;
        }
    });
    $(".spaces__text").slick({
        speed: 1000,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.spaces__image',

    });

    $(".slider-expanded__image").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        arrows: true,
        asNavFor: '.slider-expanded__text',
        appendArrows: '.slider-expanded__arrows',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1
                }
            }

        ]
    });

    $(".slider-expanded__text").slick({
        speed: 1000,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.slider-expanded__image'
    });

    let venues__filter = document.querySelectorAll(".venues__filter a");

    venues__filter.forEach((value, index) => {
        value.addEventListener("click", function (e) {
            e.preventDefault()

            venues__filter.forEach((value, index) => {
                value.classList.remove("active");
            })

            let tag = this.classList[0]

            value.classList.add("active");

            if (tag == "dropdown")
                return

            let venues__item = document.querySelectorAll(".venues__item");
            venues__item.forEach((value, index) => {

                if (value.classList.contains(tag) || tag == "all")
                    value.classList.remove("hidden")
                else
                    value.classList.add("hidden")

            })

        })
    })

    let capacity_room = document.querySelectorAll(".js-capacity_room li");
    let comp_sup = 0;
    let comp_inf = 0;
    capacity_room.forEach((value, index) => {

        value.addEventListener("click", (e) => {

            $('.venues__filter .dropdown').find('span').html(value.innerHTML);

            let cat = value.classList[0]
            switch (cat) {
                case "cat_1":
                    comp_sup = 99;
                    comp_inf = 0;
                    break;
                case "cat_2":
                    comp_sup = 499;
                    comp_inf = 100;
                    break;
                case "cat_3":
                    comp_sup = 1000;
                    comp_inf = 500;
                    break;
            }

            let venues__item = document.querySelectorAll(".venues__item")

            venues__item.forEach((elemment, index) => {

                let has_cap = false;
                elemment.classList.forEach((value, index) => {

                    if (value.indexOf("cap_") != "-1") {
                        let cap = value.replace("cap_", "") * 1;
                        has_cap = true;

                        if (cap >= comp_inf && cap <= comp_sup) {
                            elemment.classList.remove("hidden")
                        } else {
                            elemment.classList.add("hidden")
                        }
                    }

                })

                if (!has_cap)
                    elemment.classList.add("hidden")

            })

            setTimeout(() => {
                document.querySelector(".venues__filter .dropdown").classList.remove("active");
            }, 5)

        })

    });

    $('.venues__view-options .options a').click(function (e) {
        e.preventDefault();

        $('.venues__view-options .options a').removeClass('active');
        $(this).addClass('active');

        var is_list = $(this).hasClass('options__list');

        var listViewElement = $('.venues__items');
        var chartViewElement = $('.venues__chart');

        if (is_list) {
            listViewElement.removeClass('d-none');
            chartViewElement.addClass('d-none');
        }
        else {
            listViewElement.addClass('d-none');
            chartViewElement.removeClass('d-none');
        }
    });

        // Mobile Selects filter location
        const selectlocation = document.querySelector(".mobile-location-js");
        if(selectlocation){
            selectlocation.addEventListener("change", (event) => {
                console.log();
                document.querySelectorAll(".venues__item").forEach(element => {
                    element.classList.add("hidden")
                    if (element.classList.contains(event.target.value)) {
                        element.classList.remove("hidden")
                    }
                });
              });
        }

        // Mobile Selects filter capacity
        const selectcapacity = document.querySelector(".mobile-capacity-js");
        if (selectcapacity) {
            selectcapacity.addEventListener("change", (event) => {
                document.querySelectorAll(".venues__item").forEach(element => {
                    let cat = event.target.value;
                    switch (cat) {
                        case "cat_1":
                            comp_sup = 99;
                            comp_inf = 0;
                            break;
                        case "cat_2":
                            comp_sup = 499;
                            comp_inf = 100;
                            break;
                        case "cat_3":
                            comp_sup = 1000;
                            comp_inf = 500;
                            break;
                    }

                    let searchclass = element.className.split(' ');
                    searchclass.forEach( itemclass =>{
                        
                        if (itemclass.indexOf("cap_") != "-1") {
                            let cap = itemclass.replace("cap_", "") * 1;
    
                            if (cap >= comp_inf && cap <= comp_sup) {
                                element.classList.remove("hidden")
                            } else {
                                element.classList.add("hidden")
                            }
                        }
                    })

                });
              });
        }
})();
